import { MessageSquare, Star, Users } from 'lucide-react'
import type { ReactNode } from 'react'

function Tile({ icon, label, value, sub }: { icon: ReactNode; label: string; value: string; sub?: string }) {
  return (
    <div className="card-pad">
      <div className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wide text-ink-400">
        <span className="text-ink-300">{icon}</span> {label}
      </div>
      <div className="mt-1.5 text-2xl font-bold text-ink-900">{value}</div>
      {sub && <div className="text-xs text-ink-400">{sub}</div>}
    </div>
  )
}

/**
 * Listing views are deliberately absent: nothing in the schema counts them, and a tile showing a
 * number the platform never measured is worse than no tile.
 */
export function TutorStats({
  connections,
  enquiries,
  averageRating,
  ratingCount,
}: {
  connections: number
  enquiries: number
  averageRating: number | null
  ratingCount: number
}) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
      <Tile icon={<Users size={13} />} label="Connections" value={String(connections)} />
      <Tile
        icon={<Star size={13} />}
        label="Avg rating"
        value={averageRating != null ? averageRating.toFixed(1) : '--'}
        sub={ratingCount ? `${ratingCount} rating${ratingCount === 1 ? '' : 's'}` : 'No ratings yet'}
      />
      <Tile
        icon={<MessageSquare size={13} />}
        label="Enquiries"
        value={String(enquiries)}
        sub="Requests waiting on you"
      />
    </div>
  )
}
